export default {
  hasSelectedServices: state => state.servicePageData.services.length,

  getServicePageData: state => state.servicePageData,

  getSelectedSubServices: (state, getters, rootState, rootGetters) =>
    state.servicePageData.services.map(serviceId => ({
      ...rootGetters['definitions/subServicesMap'][serviceId],
      key: serviceId,
    })),

  selectedCarePlan: state =>
    state.servicePageData && state.servicePageData.selectedCarePlan,
}
